import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Button from "../ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { CheckLineIcon, CloseLineIcon } from "../../icons";
import { updateUserSubscription, resetUpdateUserSubscription, getUserSubscriptionById, resetUserSubscriptionById, getAllSubscriptions, resetGetAllSubscriptions, emptyReduxSubscription } from "../../actions/subscriptionAction";
import { getAllCustomers, resetGetAllCustomers } from "../../actions/userAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { logout } from '../../helpers/userAuth';

export default function EditUserSubscription() {

  dayjs.extend(relativeTime);

  const { id } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const updateUserSubscriptionRes = useSelector(state => state.subscriptionReducer.updateUserSubscription);

  const updateUserSubscriptionFailed = useSelector(state => state.subscriptionReducer.updateUserSubscriptionFailed);

  const getUserSubscriptionRes = useSelector(state => state.subscriptionReducer.getUserSubscription);

  const getUserSubscriptionFailed = useSelector(state => state.subscriptionReducer.getUserSubscriptionFailed);

  const getAllSubscriptionPlanRes = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlan);
  
  const getAllSubscriptionPlanFailed = useSelector(state => state.subscriptionReducer.getAllSubscriptionPlanFailed);

  const getAllCustomerRes = useSelector(state => state.userReducer.getAllCustomer);

  const getAllCustomerFailed = useSelector(state => state.userReducer.getAllCustomerFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showLoginLoader, setShowLoginLoader] = useState(false);
  
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [user, setUser] = useState("");
  const [errorUser, setErrorUser] = useState(false);

  const [subscription, setSubscription] = useState("");
  const [errorSubscription, setErrorSubscription] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [errorStartDate, setErrorStartDate] = useState(false);

  const [endDate, setEndDate] = useState("");
  const [errorEndDate, setErrorEndDate] = useState(false);

  const [subscriptionList, setSubscriptionList] = useState([]);

  const [usersList, setUsersList] = useState([]);

  const [subscrTenure, setSubscrTenure] = useState("");

  const [subscrSchedule, setSubscrSchedule] = useState("");

  
  const subscriptionOptions = [];
  
  useEffect(() => {
    dispatch(checkAuth());
    dispatch(resetUpdateUserSubscription());
    dispatch(getUserSubscriptionById(id));
    dispatch(getAllSubscriptions());
    dispatch(getAllCustomers());

  }, [id]);
  

  useEffect(() => {
    if(checkAuthFailed.statusCode == 401){
        //dispatch(emptyRedux());
        dispatch(emptyReduxUser());
        dispatch(emptyReduxSubscription());
        logout();
        navigate("/signin");
    }
  }, [checkAuthFailed]);


  useEffect(() => {

    if(typeof getAllSubscriptionPlanRes != "undefined" && getAllSubscriptionPlanRes.statusCode == 200){

      if(getAllSubscriptionPlanRes.data.plans.length > 0){

        let planList = getAllSubscriptionPlanRes.data.plans;

        const newSubArray = planList.map((item) => {
          return {
            value: item.id,
            label: item.name
          };
        });

        setSubscriptionList([
                ...newSubArray
        ]);
      }
    }

  }, [getAllSubscriptionPlanRes]);


  useEffect(() => {
    if(getAllSubscriptionPlanFailed.statusCode == 401){
      dispatch(emptyReduxUser());
      dispatch(emptyReduxSubscription());
      logout();
      navigate("/login");
          
    }
  }, [getAllSubscriptionPlanFailed]);


  useEffect(() => {

    if(typeof getAllCustomerRes != "undefined" && getAllCustomerRes.statusCode == 200){

      if(getAllCustomerRes.data.users.length > 0){

        let usrList = getAllCustomerRes.data.users;

        const newUserArray = usrList.map((item) => {
          console.log("item.userID", item);
          return {
            value: item.userId,
            label: item.firstName+' '+item.lastName
          };
        });

        setUsersList([
                ...newUserArray
        ]);
      }
    }
  }, [getAllCustomerRes]);


  useEffect(() => {
    if(getAllCustomerFailed.statusCode == 401){

      dispatch(emptyReduxUser());
      dispatch(emptyReduxSubscription());
      logout();
      navigate("/signin");
          
    }
  }, [getAllCustomerFailed]);
  
   useEffect(() => {
      if (typeof getUserSubscriptionRes !== "undefined" && getUserSubscriptionRes.statusCode === 200) {
        const data = getUserSubscriptionRes.data;
        
          setUser(data.userId);
          setSubscription(data.subscriptionPlanId);
          setStartDate(dayjs(data.startDate).format('YYYY-MM-DD'));
          setEndDate(dayjs(data.endDate).format('YYYY-MM-DD'));
        
      }
    }, [getUserSubscriptionRes]);

  useEffect(() => {
    
    if(typeof updateUserSubscriptionRes != "undefined" && updateUserSubscriptionRes.statusCode == 200){

      //setShowSuccessAlert(true);
      toast.success("Subscriber successfully Updated.", {
              position: "bottom-right",
              autoClose: 4000,
      });

      // setUser("");
      // setErrorUser(false);

      // setSubscription("");
      // setErrorSubscription(false);

      // setStartDate("");
      // setErrorStartDate(false);

      // setEndDate("");
      // setErrorEndDate(false);

      setShowLoginLoader(false);
      dispatch(resetUpdateUserSubscription());
      // setTimeout(() => {
      //   setShowSuccessAlert(false);
      // },6000);
    }

  }, [updateUserSubscriptionRes]);


  useEffect(() => {
    if(updateUserSubscriptionFailed.statusCode == 401){

      dispatch(emptyReduxUser());
      dispatch(emptyReduxSubscription());
      logout();
      navigate("/signin");
          
    }
  }, [updateUserSubscriptionFailed]);

  const addDate = (currentDate, count, schedule) => {

    let newDate = new Date(currentDate);

    if(schedule === "yearly"){
      newDate.setFullYear(newDate.getFullYear() + count);
    }

    if(schedule === "monthly"){
      newDate.setMonth(newDate.getMonth() + count);
    }

    if(schedule === "weekly"){
      newDate.setDate(newDate.getDate() + count * 7);
    }

    return newDate;
  }


  const handleChange = (input, event) => {
    
    var value = (input == "user" || input == "subscription") ? event : event.target.value;

    if(input == "user"){
      setUser(value);
    }

    if(input == "subscription"){

      setSubscription(value);

      let changedSubData = {};

      if(getAllSubscriptionPlanRes.data.plans.length > 0){

        getAllSubscriptionPlanRes.data.plans.forEach(function(item, index) {

          if(value == item.id){

            changedSubData = item;

            setSubscrTenure(item.tenure);

            setSubscrSchedule(item.schedule);
          }
        });

      }

      if(typeof changedSubData.id !== "undefined"){

        let tmpEndData = addDate(new Date(), changedSubData.tenure, changedSubData.schedule);

        setStartDate(dayjs(new Date()).format('YYYY-MM-DD'));

        setEndDate(dayjs(tmpEndData).format('YYYY-MM-DD'));
      }
      
    }

    if(input == "startDate"){
      

      let tmpDate = new Date(value);

      console.log("tmpDate", tmpDate);
      console.log("typeof tmpDate", typeof tmpDate);

      if(tmpDate != "Invalid Date"){

        let tmpEndData = addDate(new Date(tmpDate), subscrTenure, subscrSchedule);

        setStartDate(value);

        setEndDate(dayjs(tmpEndData).format('YYYY-MM-DD'));
      }

      //console.log("startDate Value and tmpDate", tmpDate);

      
      //tmpDate.setFullYear();
      //tmpDate.setMonth(tmpDate.getMonth() + count);
      //tmpDate.setDate(tmpDate.getDate() + count * 7);
    }

  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setErrorUser(false);
    setErrorSubscription(false);
    setErrorStartDate(false);
    setErrorEndDate(false);


    var err = [];
    if(String(user).replace(/\s/g, '') == ""){
      err.push("user");
      setErrorUser(true);
    }

    if(String(subscription).replace(/\s/g, '') == ""){
      err.push("subscription");
      setErrorSubscription(true);
    }

    if(String(startDate).replace(/\s/g, '') == ""){
      err.push("startDate");
      setErrorStartDate(true);
    }

    if(String(endDate).replace(/\s/g, '') == ""){
      err.push("endDate");
      setErrorEndDate(true);
    }
    
    if(err.length === 0){

        let data = {
          "userId" : parseInt(user),
          "subscriptionPlanId" : subscription,
          "startDate" : startDate,
          "endDate" : endDate,
        };

        setShowLoginLoader(true);

        dispatch(updateUserSubscription(id,data));
    }
    else
    {
      toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }
  };

  const resetForm = (e) => {
      e.preventDefault();
      setUser("");
      setErrorUser(false);

      setSubscription("");
      setErrorSubscription(false);

      setStartDate("");
      setErrorStartDate(false);

      setEndDate("");
      setErrorEndDate(false);
  }
  
  return (
    <div>
      <PageMeta
        title="Edit Subscriber | Chit Fund Management System"
        description="Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Subscribers" />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
        <div className="space-y-12">
          <ComponentCard title="Edit Subscriber">

          {(
            showSuccessAlert 

            ? 

            <Alert
              variant="success"
              title="Done!"
              message="Subscriber successfully Updated."
              showLink={false}
            />

            : 
            
            null
          )}
          
          <form onSubmit={handleSubmit} className='fadein'>
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
              <div className="space-y-6">

                <div>
                  <Label>User <span className="text-red-500">*</span></Label>
                  
                  {/* <Select
                    options={usersList}
                    placeholder="Select user"
                    value={user}
                    error={errorUser}
                    onChange={(e) => handleChange("user", e)}
                    className="dark:bg-dark-900"
                    hint={errorUser ? "This field is required." : ""}
                  /> */}
                  <select 
                  value={user} 
                  onChange={(e) => handleChange("user", e.target.value)} 
                  className="w-full rounded-md border border-gray-300 p-2 dark:border-gray-700 dark:bg-dark-900"
                  >
                  <option value="" disabled>Select user</option>
                  {usersList.map(option => (
                  <option key={option.value} value={option.value}>
                  {option.label}
                  </option>
                  ))}
                  </select>
                  {errorUser && <p className="text-sm text-red-500">This field is required.</p>}
                </div>

                <div>
                  <Label>Start Date <span className="text-red-500">*</span><small> - DD/MM/YYYY</small></Label>
                  <Input 
                    type="date" 
                    placeholder="DD/MM/YYYY" 
                    error={errorStartDate}
                    value={startDate} 
                    onChange={(e) => handleChange("startDate", e)} 
                    hint={errorStartDate ? "This field is required." : ""} 
                    min={"2025-04-02"}
                  />
                </div>

              </div>

              <div className="space-y-6">
                <div>
                  <Label>Subscription Plan <span className="text-red-500">*</span></Label>

                  {/* <Select
                    options={subscriptionList}
                    placeholder="Select an option"
                    value={subscription}
                    error={errorSubscription}
                    onChange={(e) => handleChange("subscription", e)}
                    className="dark:bg-dark-900"
                    hint={errorSubscription ? "This field is required." : ""}
                  /> */}
                  <select 
                  value={subscription} 
                  onChange={(e) => handleChange("subscription", e.target.value)} 
                  className="w-full rounded-md border border-gray-300 p-2 dark:border-gray-700 dark:bg-dark-900"
                  >
                  <option value="" disabled>Select an option</option>
                  {subscriptionList.map(option => (
                  <option key={option.value} value={option.value}>
                  {option.label}
                  </option>
                  ))}
                  </select>
                  {errorSubscription && <p className="text-sm text-red-500">This field is required.</p>}
                </div>
                <div>
                  <Label>End Date <span className="text-red-500">*</span><small> - DD/MM/YYYY</small></Label>
                  <Input 
                    type="date" 
                    placeholder="DD/MM/YYYY" 
                    error={errorEndDate}
                    value={endDate} 
                    onChange={(e) => handleChange("endDate", e)} 
                    hint={errorEndDate ? "This field is required." : ""} 
                    disabled
                  />
                </div>
               

              </div>
              <div className="space-x-6">
                  <Button size="sm" variant="primary" startIcon={( showLoginLoader ? null : <CheckLineIcon />)}>
                    {(
                      showLoginLoader 

                      ? 

                      <span class="animate-spin" ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="10" cy="10" r="8.75" stroke="white" stroke-width="2.5"></circle><mask id="path-2-inside-1_3755_26472" fill="white"><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z"></path></mask><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z" stroke="white" stroke-width="4" mask="url(#path-2-inside-1_3755_26472)"></path></svg></span>

                      : 
                      
                      null
                    )}
                    Submit
                  </Button>
                  <Button size="sm" onClick={resetForm} variant="outline" startIcon={<CloseLineIcon />}>
                    Cancel
                  </Button>
              </div>
            </div>
            </form>
          </ComponentCard>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
